import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { RuntimeConfigService } from '../../core/config/runtime-config.service';

export type StripeCheckoutSessionPayload = {
  companyName: string;
  email: string;
  requestedPlans: Array<{
    planKey: string;
    quantity: number;
  }>;
};

export type StripeCheckoutSessionResponse = {
  url: string;
};

export type StripeCheckoutConfirmationResponse = {
  confirmed: boolean;
  sessionId: string;
  status: string;
  paymentStatus: string;
  alreadyProcessed?: boolean;
  confirmationProcessedAt?: string;
};

@Injectable({ providedIn: 'root' })
export class LandingCheckoutService {
  private readonly http = inject(HttpClient);
  private readonly runtimeConfig = inject(RuntimeConfigService);

  private get apiBaseUrl(): string {
    return `${this.runtimeConfig.getConfig().backendBaseUrl}/api/stripe`;
  }

  createCheckoutSession(payload: StripeCheckoutSessionPayload): Observable<StripeCheckoutSessionResponse> {
    return this.http.post<StripeCheckoutSessionResponse>(`${this.apiBaseUrl}/create-checkout-session`, payload);
  }

  confirmCheckoutSession(sessionId: string): Observable<StripeCheckoutConfirmationResponse> {
    return this.http.post<StripeCheckoutConfirmationResponse>(`${this.apiBaseUrl}/confirm-checkout-session`, {
      sessionId,
    });
  }
}
